/* ==========================================================================
   PWR PRODUCTS
   ----------------------------------------------------------------------------
   Section controller for "Featured Products". The ONLY behaviour it adds is
   client-side filter pills: clicking a pill shows/hides already-rendered
   product cards by tag — NO refetch, NO re-render, NO duplicate product query.
   The products are rendered once by Liquid; this only toggles visibility.

   Reused, NOT reimplemented:
     - Quick add / wishlist  -> pwr-cart.js (delegated, still bound after filter)
     - Reveal                -> pwr-animation.js
     - Section lifecycle     -> JS Core (registerSection)
     - Utilities             -> JS Core utils

   Registered via PWR.registerSection => Theme Editor safe, no double init.
   Transitions are CSS (opacity/transform); JS only toggles a hidden attribute
   and an .is-active class. Fully functional without JS: with JS off, all pills
   and all products simply remain visible (progressive enhancement).
   ========================================================================== */
(function () {
  'use strict';

  if (!window.PWR || !window.PWR.registerSection) return;
  var PWR = window.PWR;
  var utils = PWR.utils;
  var Section = PWR.Section;

  function Products(root) {
    Section.call(this, root);
  }
  Products.prototype = Object.create(Section.prototype);
  Products.prototype.constructor = Products;

  Products.prototype.init = function () {
    this.pills = this.$$('[data-pwr-filter]');
    this.items = this.$$('[data-pwr-product-item]');
    if (!this.pills.length || !this.items.length) return;

    this._activeFilter = 'all';
    this._bindPills();
  };

  Products.prototype._bindPills = function () {
    var self = this;
    this.pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        self.filter(pill.getAttribute('data-pwr-filter'), pill);
      });
    });
  };

  /**
   * Show only items whose tag list contains `tag`. 'all' shows everything.
   * @param {string} tag
   * @param {Element} pill  The activated pill (for aria + active state).
   */
  Products.prototype.filter = function (tag, pill) {
    if (tag === this._activeFilter) return;
    this._activeFilter = tag;

    // Pill active state (single active, roving pressed state).
    this.pills.forEach(function (p) {
      var on = p === pill;
      p.classList.toggle('is-active', on);
      p.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    // Toggle item visibility by tag. Uses the hidden attribute so filtered-out
    // cards are removed from the a11y tree and tab order.
    var shown = 0;
    this.items.forEach(function (item) {
      var tags = (item.getAttribute('data-tags') || '').split(',');
      var match = tag === 'all' || tags.indexOf(tag) !== -1;
      item.hidden = !match;
      if (match) shown++;
    });

    // Announce the result for screen readers.
    if (utils.announce) {
      utils.announce(shown + (shown === 1 ? ' product' : ' products'));
    }
  };

  PWR.registerSection('pwr-products', function (root) { return new Products(root); });
})();
